export default "__VITE_PUBLIC_ASSET__c26197dc__"